import { render } from "./Feedback.vue?vue&type=template&id=2caa9e52&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=ts"
export * from "./Feedback.vue?vue&type=script&lang=ts"

import "./Feedback.vue?vue&type=style&index=0&id=2caa9e52&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2caa9e52"

export default script